
<template>
  <div>
    <v-overlay :value="isLoading">
  <v-progress-circular
    indeterminate
    size="64"
  ></v-progress-circular>
</v-overlay>

    <v-data-table
      :headers="headers"
      :items="mapafrequencia.items"      
      :sort-desc="true"      
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">            
          <v-row>
            <v-col cols="12" sm="3" md="3"> <v-toolbar-title>Mapa de Frequência dos estudantes</v-toolbar-title></v-col>
          <v-col cols="12" sm="3" md="3">
              <v-select
                :items="Listaranoslectivo"
                v-model="anolectivo"
                item-value="descricao"
                item-text="novadescricao"
                @change="carregarCursos()"
                label="Selecione o Ano lectivo"
                outlined
                return-object
              ></v-select>      
  </v-col>
  <v-col cols="12" sm="4" md="4">
              <v-select
                :items="cursos"
                v-model="curso"
                item-value="idCurso"
                item-text="curso"
                @change="carregarMapaFrequencia()"
                label="Selecione o Curso"
                outlined
                :disabled="!anolectivo"
                return-object
              ></v-select>      
  </v-col>
  <v-col cols="12" sm="2" md="2">
    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn large fab color="#006699" @click="comporHTML()"
                        :disabled="!mapafrequencia.items.length"
                          v-bind="attrs"
                          v-on="on"
                        >
                        <v-icon color="white" :disabled="!mapafrequencia.items.length">print</v-icon>
                          </v-btn>
                      </template>
                      <span>Clique aqui para visualizar o PDF</span>
                  </v-tooltip>
    </v-col>
</v-row>
          <v-spacer></v-spacer>    
        </v-toolbar>
</template>          
      <template v-slot:no-data>
        no data
      </template>
    </v-data-table>
  
     
  </div>
  </template>
<script>
import axios from '../../../../plugins/axios'
import impressao from '../../../../utilitarios/impressao.utilitario'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
data: () => ({
relatorio: '',
mapafrequencia: {items:[],totais:null},
html: ``,
isLoading: true,
Listaranoslectivo: [],
cursos:[],
curso: null,
anolectivo: null,

headers: [
  {
    text: 'Classes',
    align: 'left',
    sortable: false,
    value: 'classe'
  },
  { text: 'Matriculados', value: 'mfmatriculados' },
   { text: 'Aprovados', value: 'mfaprovados' },
  { text: 'Reprovados', value: 'mfreprovados' },
  { text: 'Transferidos', value: 'mftransferidos' },
  { text: 'Desistidos', value: 'mfdesistentes' },
],

}),
computed: {
},
watch: {
},
created  () {
this.carregarRelatorio()   
this.carregarAnosLectivo() 
},
methods: {
async carregarAnosLectivo () {
  try {
    this.isLoading = true
    this.Listaranoslectivo = await axios
      .get('/listarAnoLectivoAll')
      .then(res => res.data)
  } catch (error) {
    Swal.fire({icon: 'error',title: '',text: 'Ocorreu um erro ao carregar os anos lectivos' })    
    this.isLoading = false
  } finally {
    this.sair()
  }
},
async carregarCursos () {
  try {
    this.curso = null
    this.isLoading = true
    this.cursos = await axios.get('/obtercursosMinistradoByAnoLectivo/'+ this.anolectivo.descricao).then(res => res.data)
  } catch (error) {
    Swal.fire({icon: 'error',title: '',text: 'Ocorreu um erro ao carregar os anos lectivos' })    
    this.isLoading = false
  } finally {
    this.sair()
  }
},
async carregarRelatorio () {
  try {
    this.isLoading = true
    this.relatorio = await axios.get('/obterRelatorioByDescricao/mac').then(res => res.data) 
  } catch (error) {
    this.sair()
    Swal.fire({icon: 'error',title: '',text: 'Ocorreu um erro ao carregar o relatório' })
  }
},
async carregarMapaFrequencia () {
  try {     
    this.isLoading = true   
    let params = { anolectivo: this.anolectivo.descricao,idCurso: this.curso.idCurso }
    this.mapafrequencia = await axios.post('/obterMapaAproveitamentoByAnoLectivo', params).then(res => res.data) 
 
  } catch (error) {
    this.sair()
    Swal.fire({icon: 'error',title: '',text: 'Ocorreu um erro ao carregar o mapa de frequência' })
  } finally {
    this.sair()
  }
},
comporHTML () {
  try {
    this.isLoading = true
    this.html = this.relatorio[0].documento
    let documentoiter = this.relatorio[0].documentoiteracao1
    let header = this.relatorio[0].documentoiteracao2
    
    this.html = this.html.replace(/{{instituicaodescricao}}/g, ls.get('instituicaodescricao').toUpperCase())
    this.html = this.html.replace(/{{anolectivo}}/g, this.anolectivo.novadescricao)
    this.html = this.html.replace(/{{dataactual}}/g, this.correntDate()) 
    /**Totais */
    this.html = this.html.replace(/{{mf_matriculados}}/g, this.mapafrequencia.totais.mfmatriculados)
    this.html = this.html.replace(/{{f_matriculados}}/g, this.mapafrequencia.totais.fmatriculados)
    this.html = this.html.replace(/{{mf_aprovados}}/g, this.mapafrequencia.totais.mfaprovados)

    this.html = this.html.replace(/{{f_aprovados}}/g, this.mapafrequencia.totais.faprovados)
    this.html = this.html.replace(/{{mf_reprovados}}/g, this.mapafrequencia.totais.mfreprovados)
      this.html = this.html.replace(/{{f_reprovados}}/g, this.mapafrequencia.totais.freprovados)
      this.html = this.html.replace(/{{mf_transferidos}}/g, this.mapafrequencia.totais.mftransferidos)

      this.html = this.html.replace(/{{f_transferidos}}/g, this.mapafrequencia.totais.ftransferidos)
      this.html = this.html.replace(/{{mf_desistidos}}/g, this.mapafrequencia.totais.mfdesistidos)
      this.html = this.html.replace(/{{f_desistidos}}/g, this.mapafrequencia.totais.fdesistidos)

   
    let dados = ``

    this.mapafrequencia.items.forEach(element => {
      this.html = this.html.replace(/{{curso}}/g, element.curso) 
      let iteracao = documentoiter
      iteracao = iteracao.replace(/{{classe}}/g, element.classe)
      iteracao = iteracao.replace(/{{mf_matriculados}}/g, element.mfmatriculados)
      iteracao = iteracao.replace(/{{f_matriculados}}/g, element.fmatriculados)
      iteracao = iteracao.replace(/{{mf_aprovados}}/g, element.mfaprovados)

      iteracao = iteracao.replace(/{{f_aprovados}}/g, element.faprovados)
      iteracao = iteracao.replace(/{{mf_reprovados}}/g, element.mfreprovados)
      iteracao = iteracao.replace(/{{f_reprovados}}/g, element.freprovados)
      iteracao = iteracao.replace(/{{mf_transferidos}}/g, element.mftransferidos)

      iteracao = iteracao.replace(/{{f_transferidos}}/g, element.ftransferidos)
      iteracao = iteracao.replace(/{{mf_desistidos}}/g, element.mfdesistentes)
      iteracao = iteracao.replace(/{{f_desistidos}}/g, element.fdesistentes)
      

      dados += iteracao
  })
  this.html = this.html.replace(/{{css}}/g, this.relatorio[0].css)
  this.html = this.html.replace(/{{dados}}/g, dados)
    let options = { 'format': 'A4',
    'orientation': 'landscape',
    'border': {
      'right': '12mm',
      'left': '12mm'
    },
    'header': {
      'height': '10mm',
      'contents': { first: header } },
    'footer': {
      'height': '10mm'

    } }
    impressao.htmlToPDF(this.html,options,ls.get('urlReport'),ls.get('idPessoa'))
  } catch (error) {
    this.sair()
    Swal.fire({icon: 'error',title: '', text: 'Ocorreu um erro ao abrir o documento'})
  } finally {
    this.sair()
  }
},   
sair(){ this.isLoading =false },
correntDate () {
  let data = new Date()
  var month = []
  month[0] = 'Janeiro'
  month[1] = 'Fevereiro'
  month[2] = 'Março'
  month[3] = 'Abril'
  month[4] = 'Maio'
  month[5] = 'Junho'
  month[6] = 'Julho'
  month[7] = 'Agosto'
  month[8] = 'Setembro'
  month[9] = 'Outubro'
  month[10] = 'Novembro'
  month[11] = 'Dezembro'
  return  ls.get('instituicaodescricao').toUpperCase() + ', ' + data.getDate().toString() + ' de ' + month[(data.getMonth())] + ' de ' + data.getFullYear().toString()
}
}
}

</script>
